/*
  Simple function to check whether or not
  the browser has touch capabilities
*/
export default function isTouchDevice () {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0))
}
